import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import Vue from "vue";
import axios from "axios";
import Notify from 'quasar/src/plugins/Notify.js';;
import { routerInstance } from "boot/router";
import { env } from "src/config/env";
import jwt_decode from "jwt-decode";
var axiosInstance = axios;
var statusCode = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  REQUEST_TIMEOUT: 408,
  UNSUPPORTED_MEDIA_TYPE: 415
};
var api = env.apiUrl;
if (api) {
  axiosInstance = axios.create({
    baseURL: api
  });
} else {
  Notify.create({
    message: "API não foi configurada corretamente",
    color: "negative",
    timeout: 0,
    actions: [{
      label: "Configurar",
      color: "white",
      handler: function handler() {
        if (routerInstance.currentRoute.path !== "/manage/api") {
          routerInstance.push("/manage/api");
        }
      }
    }]
  });
}
axiosInstance.interceptors.request.use(function (req) {
  var token = localStorage.getItem('painel-web-auth-token');
  if (token) {
    if (jwt_decode(token).expiration < new Date().getTime()) {
      localStorage.removeItem('painel-web-auth-token');
      return Promise.reject(new ErrorHandler("* Token expirado, tente logar novamente", statusCode.UNAUTHORIZED, false));
    }
  } else {
    if (req.url.toUpperCase() === "/CLIENTES") {
      return req;
    } else {
      routerInstance.push({
        path: "/",
        query: {
          "q": "* Usuário não logado"
        }
      });
    }
  }
  if (req.headers["Authorization"] === undefined) {
    req.headers["Authorization"] = "Bearer " + token;
  }
  return req;
}, function (reject) {
  return reject;
});
axiosInstance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var response = error.response;
  if (response.data && response.data && response.data.hasOwnProperty("status") && response.data.status >= 400 && response.data.status <= 499) {
    return response;
  } else {
    return Promise.reject(new ErrorHandler("Erro desconhecido", 500, false), true);
  }
});
function ErrorHandler(message, statusCode, auth) {
  this.data = {
    auth: auth,
    message: message,
    statusCode: statusCode
  };
}
Vue.prototype.$axios = axiosInstance;